core.constant('secondDiagnosisMeedyTranslationPL', {
  "T": {
    "MEEDY": {
      "SYSTEM": {
        "MESSAGE": {
        }
      },
      "UI": {
        "TABBAR": {
          "SECOND_DIAGNOSIS": {
            "SECOND_DIAGNOSIS": "Zapytaj laboratorium"
          }
        },
        "BREADCRUMB": {
          "SECOND_DIAGNOSIS": {
            "SECOND_DIAGNOSIS": "Zapytaj laboratorium",
            "SECOND_DIAGNOSISES": "Zapytaj laboratorium",
            "CREATE": "Dodaj",
            "EDIT": "Edycja",
            "VIEW": "Dane"
          }
        },
        "SIDEBAR": {
          "SECOND_DIAGNOSIS": "Zapytaj laboratorium"
        },
        "BUTTON": {
          "SECOND_DIAGNOSIS": {
            "SAVE_WORK_VERSION": "Zapisz wersje roboczą",
            "SEND": "Wystaw opinię",
            "GENERAL_INTERVIEW": "Wywiad ogólny",
            "REJECT_BY_PHYSICIAN": "Odrzuć ze względu na nieadekwatność",
            "REJECT_BY_PHYSICIAN_INCOMPETENCE": "Przekaż innemu diagnoście"
          }
        }
      },
      "ENUM": {
        "ADDITIVIES_FOR_INJURY": {
          "CRUTCHES" : "Kule",
          "WHEELCHAIR" : "Wózek inwalidzki",
          "DENTURES" : "Protezy",
          "OTHER" : "Inne"
        },
        "SECOND_DIAGNOSIS_STATUS": {
          "WAITING_FOR_PAYMENT" : "Oczekuje na płatność",
          "PRE_VALIDATED" : "Trwa przetwarzanie",
          "VALIDATED" : "Zatwierdzona",
          "REJECTED" : "Odrzucona",
          "REJECTED_BY_CONSULTANT" : "Odrzucona przez konsultanta",
          "REJECTED_BY_PHYSICIAN" : "Odrzucona ze wzgl. na nieadekwatność",
          "REJECTED_BY_PHYSICIAN_INCOMPETENCE" : "Przekazanie innemu diagnoście",
          "MISSING_DATA" : "Brakuje danych",
          "CANCELLED" : "Anulowana",
          "DONE" : "Wykonana",
          "UNSEND" : "Niewysłana",
          "IN_PROGRESS" : "W trakcie"
        },
        "SECOND_DIAGNOSIS_TYPE": {
          "SECOND_DIAGNOSIS": "Druga diagnoza",
          "LAB_RESULTS_INTERPRETATION": "Interpretacja laboratoryjna wyniku",
          "PREVENTIVE_CONSULTATION": "Konsultacja profilaktyczna przed badaniem",
          "GENETIC_CONSULTATION": "Porada genetyka"
        }
      },
      "MODULE": {
        "TITLE": {
          "SECOND_DIAGNOSIS": {
            "EDIT" : "Edycja"
          }
        },
        "SECOND_DIAGNOSIS": {
          "BASE_DATA" : "Dane podstawowe",
          "LIST" : "Lista",
          "SEARCH_PHRASE" : "Wpisz imię lub/i nazwisko",
          "FIRST_NAME" : "Imię",
          "LAST_NAME" : "Nazwisko",
          "PESEL" : "PESEL",
          "TYPE" : "Typ",
          "PHONE" : "Telefon",
          "SERVICE" : "Usługa",
          "STATUS" : "Status",
          "INSURANCE" : "Towarzystwo Ubezpieczeń",
          "IDENTIFIER" : "Identyfikator",
          "IDENTIFIER_TYPE" : "Typ Identyfikatora",
          "GENDER" : "Płeć",
          "BIRTH_DATE" : "Data urodzin",
          "NOTES" : "Uwagi",
          "DIAGNOSIS" : "Opinia",
          "DATES" : "Daty",
          "EXECUTION_DATE" : "Data wykonania",
          "CREATION_DATE" : "Data utworzenia",
          "VERIFICATION_DATE" : "Data przypisania",
          "PHYSICIAN_START_PROGRESS_DATE" : "Data rozpoczęcia pracy",
          "ATTACHED_FILES" : "Załączone pliki",
          "FAX" : "Fax",
          "EMAIL" : "Email",
          "CONTACT_DATA" : "Dane kontaktowe",
          "MESSAGES": {
            "START_WORK" : "Czy chcesz rozpocząć pracę nad diagnozą?"
          }
        }
      }
    }
  }
});
